import { MenuItem } from "./MenuItem.js";
import { ToggleInput } from "../Form/Controls/Toggle/Toggle.js";
import { forwardRef, useCallback, useId } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/components/Menu/ToggleMenuItem.tsx
/**
* A menu item with a toggle control.
* Must be used within a compound Menu or other `menu` or `menubar` aria role subtree.
*/
var ToggleMenuItem = forwardRef(function ToggleMenuItem({ className, Icon, label, onSelect, checked, disabled, onClick }, ref) {
	return /* @__PURE__ */ jsx(MenuItem, {
		as: "button",
		role: "menuitemcheckbox",
		"aria-checked": checked,
		className,
		Icon,
		label,
		hideChevron: true,
		onSelect,
		disabled,
		onClick,
		children: /* @__PURE__ */ jsx(ToggleInput, {
			id: useId(),
			ref,
			"aria-hidden": true,
			tabIndex: -1,
			checked,
			disabled,
			onChange: useCallback(() => {}, [])
		})
	});
});
//#endregion
export { ToggleMenuItem };

//# sourceMappingURL=ToggleMenuItem.js.map